/**
 * Token storage utility
 * Provides methods to store and retrieve JWT tokens
 */

const TOKEN_KEY = 'camionnet_jwt_token';

export const tokenStorage = {
  /**
   * Store JWT token in localStorage
   */
  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  },

  /**
   * Get JWT token from localStorage
   */
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  },

  /**
   * Remove JWT token from localStorage
   */
  removeToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  },

  /**
   * Check if JWT token exists in localStorage
   */
  hasToken(): boolean {
    return !!this.getToken();
  },
};
